import { Component, OnInit} from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder, ValidatorFn, ValidationErrors } from '@angular/forms';
import { FunctionsService } from "../services/functions.service";
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../api.service';
import { Router } from '@angular/router';
import { AppConstants } from '../app.constants';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OkModalComponent } from '../generic-components/ok-modal/ok-modal.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['../login/login.component.css']
})

export class ResetPasswordComponent implements OnInit {
    token:string;
    formSubmitted: boolean = false;
    
    constructor(private apiService: ApiService,
        private formBuilder: UntypedFormBuilder,
        public functionsService:FunctionsService, 
        private modalService: NgbModal,
        public router: Router,
        private spinner: NgxSpinnerService,  
        private translate: TranslateService){
            translate.setDefaultLang('en');
            this.functionsService.setTitle('profile.change_password');
        }

    private passwordMatchValidator: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
        const password = control.get('newPassword');
        const confirmPassword = control.get('confirmPassword');
    
        return password.value === confirmPassword.value ? null : { 'passwordsDontMatch': true };
      }

    resetPasswordForm = this.formBuilder.group({
        newPassword: ['', [Validators.required, Validators.minLength(8), Validators.pattern(AppConstants.passwordRegex)]],
        confirmPassword: ['', [Validators.required]]
      }, { validators: this.passwordMatchValidator });

    language = localStorage.getItem('language')?localStorage.getItem('language'):'en';

    ngOnInit(){
        var value = this.router.url.split('=',2);
        document.getElementById("reset-password").hidden = true;
        if(value.length>1){
            this.token = value[1].replace(/%3D/g, "=");
            //Validate token
            this.apiService.validateToken({"Token":this.token}).subscribe(
                () => {
                    //Token is valid, show page
                    document.getElementById("reset-password").hidden = false;
                },
                error => {
                  const okModalRef = this.modalService.open(OkModalComponent);
                  okModalRef.componentInstance.title = this.translate.instant('Error');
                  okModalRef.componentInstance.message = this.translate.instant('general.invalid_token');
                  this.router.navigate(['/forgotPassword']);
                }
            );
        }else{
            //Hide change password form and show error
            const okModalRef = this.modalService.open(OkModalComponent);
                  okModalRef.componentInstance.title = this.translate.instant('Error');
                  okModalRef.componentInstance.message = this.translate.instant('general.permission_denied');
            this.router.navigateByUrl('/login');
        }

        if(localStorage.getItem('language') != null){
            this.functionsService.useLanguage(localStorage.getItem('language'));
        }
    }

    resetPassword(){
        Object.keys(this.resetPasswordForm.controls).forEach(key => {
            const controlErrors: ValidationErrors = this.resetPasswordForm.get(key).errors;
            if (controlErrors != null) {
              Object.keys(controlErrors).forEach(keyError => {
                console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
              });
            }
          });
        //Do not perform an action if email is invalid
        if (!this.resetPasswordForm.valid) {
            this.formSubmitted = true;
            return;
        } 
        this.spinner.show();
        this.resetPasswordForm.value['token'] = this.token;
        this.resetPasswordForm.value['portal'] = true;
        //Call API service
        this.apiService.resetPassword(this.resetPasswordForm.value).subscribe(
            () => {
                this.spinner.hide();
                this.router.navigate(['/login']);
            },
            error => {
                this.spinner.hide();
                const okModalRef = this.modalService.open(OkModalComponent);
                  okModalRef.componentInstance.title = this.translate.instant('Error');
                  okModalRef.componentInstance.message = this.translate.instant('general.invalid_token');
                this.functionsService.errorHandler(error["status"]);
            }
        )
    }
    removeError(){
        this.formSubmitted = false;
    }

    controlGetter(controlName) {
        const control = this.resetPasswordForm.get(controlName);
        return control && (control.touched || this.formSubmitted) ? control : {};
    }
  
    backToMain() {
        this.router.navigate(['/main']);
    }

    get newPassword() { return this.controlGetter('newPassword'); }
    get confirmPassword() { return this.controlGetter('confirmPassword'); }
}